<template>
  <div>
    <div class="flex flex-wrap w-full items-center justify-center">
      <div class="flex flex-wrap w-full items-center justify-center">
        <div class="flex w-full items-center text-left hireful-font-domus text-gray-400 py-2">
          We have sent a text message with a sign-in code to the mobile number ending in xxxxxxx-{{maskedPhoneNumber}}.
        </div>
        <div class="flex w-full items-center text-left hireful-font-domus text-gray-400 py-2">
          Please enter the received code in the field below. Please note: it may take a couple of minutes for the text message to reach you.
        </div>
        <div class="flex w-full items-center text-left hireful-font-domus text-gray-400 py-2">
          If you are having issues receiving your code please get in touch with <a class="contents text-hireful-link" href="mailto:support@hireful.co.uk">support@hireful.co.uk</a>.
        </div>
      </div>
      <div class="flex flex-wrap w-full items-center justify-center">
        <div class="flex flex-wrap w-full items-center justify-start py-4">
          <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
            Sign in code
            <span class="text-hireful-yellow"> *</span>
          </div>
          <div class="flex w-full">
            <text-field v-model="signInCode" @enter="submitCode()" />
          </div>
        </div>
        <div class="flex w-full items-center justify-start">
          <div class="hireful-font-domus text-gray-400 cursor-disabled" v-if="isResendDisabled">
            you can resend code after {{resendCounter}} seconds
          </div>
          <div class="hireful-font-domus text-gray-400 cursor-pointer" @click="resendCode" v-else>
            Code not received? click to resend
          </div>
        </div>
      </div>
      <div class="flex flex-wrap w-full items-center justify-center py-2">
        <input type="checkbox" id="rememberDevice" v-model="remeberDeviceFlag">
        <label for="rememberDevice" class="hireful-font-domus text-gray-400">Remember this device</label>
      </div>
      <div class="flex flex-wrap w-full item-center justify-center py-2" v-if="showNotification">
        <hireful-notification :msg="message"></hireful-notification>
      </div>
      <div class="flex flex-wrap w-full items-center justify-center">
        <div class="flex w-full items-center justify-center">
          <loader v-if="loading || resending || checkingCode" />
          <div class="flex flex-wrap w-full items-center justify-center" v-else>
            <button class="bg-hireful text-white w-full hireful-font-semibold h-12 rounded-lg" @click="submitCode()" >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from '@/components/loader'
import hirefulNotification from '@/components/hireful-notification'
import textField from '@/components/textField'

export default {
  name: 'loginMfaStep',
  components: {
    loader,
    hirefulNotification,
    textField
  },
  props: {
    type: {
      type: String,
      default: 'SMS_MFA'
    },
    details: {
      type: Object,
      default: () => {}
    },
    showNotification: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    resending: {
      type: Boolean,
      default: false
    },
    checkingCode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      signInCode: null,
      remeberDeviceFlag: false,
      resendCounter: 59,
      isResendDisabled: false
    }
  },
  computed: {
    maskedPhoneNumber () {
      const vm = this
      if (vm.details && vm.details.CODE_DELIVERY_DESTINATION) {
        const numberSplitArr = vm.details.CODE_DELIVERY_DESTINATION.split('*')
        return numberSplitArr[numberSplitArr.length - 1]
      }
      return ''
    }
  },
  watch: {
    remeberDeviceFlag (val) {
      const vm = this
      vm.$emit('rememberDevice', vm.remeberDeviceFlag)
    }
  },
  mounted () {
    const vm = this
    vm.$emit('setPageTitle', `Code sent to xxxxxxx-${vm.maskedPhoneNumber}`)
    vm.$nextTick(() => vm.$refs.signInCodeInput.focus())
  },
  methods: {
    submitCode () {
      const vm = this
      vm.$emit('code', vm.signInCode)
    },
    resendCode () {
      const vm = this
      vm.$emit('resend', true)
      vm.resendCounter = 59
      vm.isResendDisabled = true
      vm.countDownTimer()
    },
    countDownTimer () {
      const vm = this
      if (vm.resendCounter > 0) {
        setTimeout(() => {
          vm.resendCounter -= 1
          vm.countDownTimer()
        }, 1000)
      } else {
        vm.isResendDisabled = false
      }
    }
  }
}
</script>
